export default {
  all: [],
  expires: null
};